import { Services } from "../../../Api/services";

export const fetchs3File = async url => {	
    let res = await Services.getCall(url, false);
	return { data: res.data };
};
